import { useCallback} from "react";
import { useConfigPathContext } from "../providers/ConfigPathContextProvider";
import { jp, K_INFO, useConfigsDataContext } from "../providers/ConfigsDataContextProvider";

// --- STATIC ---

const SelectorRootExact = /^\$\.rootAccount(\['[^']+'\]){8}$/;

// --- Is Root Folder
export const isRoot = (path) => {
  return SelectorRootExact.test(path);
}

// --- Get Active Folder Name ---
//
export const getFolderName = (path) => {
  const leftBreck = path.lastIndexOf("['");
  const rightBreck = path.lastIndexOf("']");
  const r = path.substr(leftBreck+2, rightBreck-leftBreck-2);
  return r;
}

export const getFolderNode = (data, path) => {
  return jp.query(data, path)[0];
}


//
// Component
//-------------------   useConfigsNavigator   -------------------------
//
export default function useConfigsNavigator() {  

  const {configPath, setConfigPath}             = useConfigPathContext();
  const {getNode}                               = useConfigsDataContext();

  // --- Go Up Folder ---
  //
  // TODO: Use special symbol for "/" Root...
  const goUpFolder = useCallback(() => {

    // Remove the last folder name from current configPath
    setConfigPath( prev => {
      if (getFolderName(prev) !== '/') {
        const lastLeftBracketPos = prev.lastIndexOf("['");
        return prev.substr(0, lastLeftBracketPos);
      }
      else {
        return prev;
      }
    });
    
  }, [setConfigPath]);

  // --- Get ConfigNode By Path ---
  // Based on latest data
  const getConfigNodeByPath = useCallback( (path) => {
    return getNode(path);
  }, [getNode]);
  

  // ---  Get Current Node --- 
  const getConfigCurNode = () => {
    return getConfigNodeByPath(configPath);
  }

  // --- Get Current Kiponos_Info
  const getConfigCurInfo = () => {
    return getConfigCurNode()[K_INFO];
  }
  
  return {    
    goUpFolder,
    getConfigNodeByPath,
    getConfigCurNode,
    getConfigCurInfo,
  }
}
